import * as React from "react";

import { Box, TextField, Grid } from "@mui/material";

import CustomButton from "../../../helper-components/input/CustomButton.jsx";

import { deleteUserMe, updateUserMe } from "../../../helper-functions/api/userQueries.js";
import { isEmpty, removeNullValues } from "../../../helper-functions/shared/miscUtils.js";

import { getLanguage } from "../../../config/language/language.js";

/**
 * Allow the user to update their account info.
 * Require password confirmation.
 */
export default function UserUpdateForm(props) {
    const user = props?.user?.me || {};

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const body = {
            email: data.get("email") || null,
            username: data.get("username") || null,
            password: data.get("password") || null
        };

        if (isEmpty(removeNullValues(JSON.parse(JSON.stringify(body))))) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_NO_CHANGES, color: "error" });
            return;
        }

        if (isNewPasswordOk(data)) {
            updateUserMe(props, { body });
        }
    };

    // Password matching check.
    const isNewPasswordOk = (data) => {
        if (data.get("password") !== data.get("passwordConfirm")) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_PASSWORD_MATCH, color: "error" });
            return false;
        }

        return true;
    };

    const showDeleteDialog = () => {
        props.showDialog({
            title: "Delete your account",
            message: `Are you sure you want to delete your account?

            The account and all associated data will be permanently deleted, and cannot be recovered.`,
            actionTitle: "Delete",
            actionColor: "error",
            callback: (confirm) => handleDelete(confirm)
        });
    };

    const handleDelete = (confirm) => {
        if (!confirm) return;

        deleteUserMe(props);
    };

    return (
        <Box className="box" component="form" onSubmit={handleSubmit}>
            <Grid container spacing={1} mb={2}>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth id="username" label="New username" placeholder={user.username} name="username" autoComplete="nickname" />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField fullWidth id="email" label="New email" placeholder={user.email} name="email" autoComplete="email" />
                </Grid>

                <Grid item xs={12}>
                    <TextField fullWidth id="password" label="New password" type="password" name="password" autoComplete="new-password" />
                </Grid>

                <Grid item xs={12}>
                    <TextField fullWidth id="passwordConfirm" label="Confirm new password" type="password" name="passwordConfirm" autoComplete="new-password" />
                </Grid>
            </Grid>

            <CustomButton {...props} title={"Update account"} type="submit" fullWidth />
            <CustomButton {...props} title={"Delete account..."} color="error" fullWidth onClick={showDeleteDialog} />
        </Box>
    );
}
